import environment from '@lib/environment';
import { devtools } from 'valtio/utils';

export const isDevToolsEnabled = () => {
  // Disable devtools in Vitest to prevent warning spam
  if (import.meta.env.VITEST) {
    return false;
  }

  const devTools = localStorage.getItem('valtioDevTools') === 'true';
  const devToolsEnabled = environment.RUNTIME_ENV !== 'prod';
  return devTools || devToolsEnabled;
};

/**
 * Initializes Valtio devtools for the given state.
 * And allows to enable/disable the devtools by setting the 'valtioDevTools' key in the localStorage to 'true' or 'false'.`
 * Allows user to debug state via Redux DevTools extension
 * https://chromewebstore.google.com/detail/redux-devtools/lmhkpmbekcpmknklioeibfkpmmfibljd?hl=en-US&utm_source=ext_sidebar
 *
 * @param {any} state - The state to be monitored by the devtools.
 * @param {string} name - The name to be displayed in the devtools.
 */

export const valtioDevTools = (state: any, name: string) => {
  devtools(state, {
    name: name,
    enabled: isDevToolsEnabled(),
  });
};
